// cspell:ignore grok

export enum AxAIGrokModel {
  Grok3 = 'grok-3',
  Grok3Mini = 'grok-3-mini',
  Grok3Fast = 'grok-3-fast',
  Grok3MiniFast = 'grok-3-mini-fast',
}

export enum AxAIGrokEmbedModels {
  GrokEmbedSmall = 'grok-embed-small', // Placeholder, update if actual models are known
}
